import pageView from './page-view'
import onboardingClicked from './onboarding-clicked'

export default {
  pageView,
  onboardingClicked,
}
